import "./newTeeSheetTabsDivision.scss";
import React, { Fragment, useCallback, useLayoutEffect, useRef, useState } from "react";
import { ITeeTimeTabNew } from "./NewTeeSheet";
import {
  calculateDivisionColors,
  IAddSqueezeTimeModal,
  IAddTeeTimeModal,
  IAuditTrailModal,
  ICancelBookingPopup,
  ICancelPlayerPopup,
  ICreateShotgunModal,
  IEditStartHoleModal,
  IFileImportModal,
  ICheckInAllLeagueParticipantsModal,
  INewTeeSheetTabsDragAndDropState,
  INewTeeSheetTabsState,
  INoShowModal,
  IRemoveShotgunPopup,
  IRemoveTeeTimePopup,
  ICheckInAllShotGunParticipantsModal,
  ITeeTimeDetailsModal,
  ITeeTimeDraggable,
  ICheckInAllTournamentParticipantsModal,
} from "./NewTeeSheetTabs";
import { ITeeTimeBookingCategory, ITeeTimeSlotNew } from "redux/reducers/models/teetime";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleG, faEllipsisV, faUsdCircle } from "@fortawesome/pro-solid-svg-icons";
import {
  faExclamationCircle,
  faBan,
  faCircle,
  faEarthAmericas,
  faPersonWalking,
  faPlusCircle,
  faRepeatAlt,
  faThunderstorm,
  faStickyNote,
  faSunrise,
  faSunset,
  faTrophy,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import RightClickMenu from "components/rightClickMenu/RightClickMenu";
import { Badge } from "components/badge/Badge";
import { CustomIcon } from "components/customIcon/CustomIcon";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { loadingTeetimeTabActionsContainsId, TNewTeeSheetLoadingTeetimeTabAction } from "./loadingTeetimeTabActions";
import Spin from "components/spin/spin";
import { convertTime, formatDate, timeToNumber, valueToString } from "helpers/Helpers";
import { Draggable, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import TeeTimeToolTip, { ITeeTimeToolTipPricing } from "components/teeTimeToolTip/teeTimeToolTip";
import { useHistory } from "react-router";
import { ILeague } from "redux/reducers/models/league";
import { ITournament } from "redux/reducers/models/tournament";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { IDivision } from "redux/reducers/models/facility";
import {
  ExportShotgunTemplate,
  GetPrintCartSigns,
  GetPrintEventAlphaList,
  GetTeeTimePricing,
} from "api/rpc/2024-04/facilityAdmin/teesheet/teeSheet";
import { StatusCode } from "api/protocols";
import { showError } from "redux/actions/ui";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { CancelToken } from "axios";
import { throttle } from "lodash";
import { TTeeSheetView } from "hooks/useTeeSheetSideBySideSettings/useTeeSheetSideBySideSettings";
import { GetEventScorecards } from "api/rpc/2024-04/facilityAdmin/event/scorecard";
import { GetTournamentOrganizer } from "api/rpc/2024-04/facilityAdmin/tournament/organizer";

export enum NewTeeSheetTabsDivisionUpdateModalType {
  NoShow = "NoShow",
  CreateShotgun = "CreateShotgun",
  AuditTrail = "AuditTrail",
  TeeTimeDetails = "TeeTimeDetails",
  EditStartHole = "EditStartHole",
  AddTeeTime = "AddTeeTime",
  AddSqueezeTime = "AddSqueezeTime",
  FileImport = "FileImport",
  RemoveShotgun = "RemoveShotgun",
  CheckInAllLeagueParticipants = "CheckInAllLeagueParticipants",
  CheckInAllTournamentParticipants = "CheckInAllTournamentParticipants",
  CheckInAllShotgunParticipants = "CheckInAllShotgunParticipants",
  CancelBooking = "CancelBooking",
  CancelPlayer = "CancelPlayer",
  BlockedTeeTime = "BlockedTeeTime",
  RemoveTeeTime = "RemoveTeeTime",
  SelectDivisions = "SelectDivisions",
  AddTournamentPlayer = "AddTournamentPlayer",
}

interface INewTeeSheetTabsDivisionProps {
  divisionClassName?: string;
  teeSheetView: TTeeSheetView;
  sortedTeeTimes: ITeeTimeTabNew[];
  groupedTeeTimes: ITeeTimeDraggable[];
  teetimeBookingCategories: ITeeTimeBookingCategory[][];
  dragAndDropState: INewTeeSheetTabsDragAndDropState;
  loadingTeetimeTabActions: TNewTeeSheetLoadingTeetimeTabAction[];
  teeSheetLeagues: ILeague[];
  teeSheetTournaments: ITournament[];
  allDivisions: IDivision[];
  handleInitiateBooking: (teetime: ITeeTimeTabNew, slot?: ITeeTimeSlotNew) => Promise<void>;
  handleEditBooking: (teetime: ITeeTimeTabNew, bookingId: number) => Promise<void>;
  updateModalState<T>(newState: Partial<T> & { isOpen?: boolean }, type: NewTeeSheetTabsDivisionUpdateModalType): void;
  updateMainState(newMainState: Partial<INewTeeSheetTabsState>): void;
  handleSelectDivisions(teetime: ITeeTimeTabNew): void;
}

export default function NewTeeSheetTabsDivision(props: INewTeeSheetTabsDivisionProps) {
  const history = useHistory();
  const { t } = useTranslation();
  const { facilityStore, teeSheetStore } = useAppSelector(store => store);
  const dispatch = useAppDispatch();

  const divisionRef = useRef<HTMLDivElement>(null);

  const [divisionWidth, setDivisionWidth] = useState<number>(null);
  const mobileSizedDivision = divisionWidth == null || divisionWidth <= MOBILE_WIDTH;

  useLayoutEffect(() => {
    if (!divisionRef.current) {
      return;
    }

    const update = throttle((entries: ResizeObserverEntry[]) => {
      setDivisionWidth(entries[0].contentRect.width);
    }, 50);

    const resizeObserver = new ResizeObserver(update);

    resizeObserver.observe(divisionRef.current);
    return () => {
      resizeObserver.disconnect();
      update.cancel();
    };
  }, [divisionRef]);

  const renderBookingParticipantIcons = (slot: ITeeTimeSlotNew) => {
    return (
      <>
        {slot.check_in_status === "checked" && (
          <FontAwesomeIcon icon={faCheckCircle} className="booking-participant_icon" />
        )}

        {slot.check_in_status !== "checked" && !slot.no_show_type && (
          <FontAwesomeIcon icon={faCircle} className="booking-participant_icon" />
        )}

        {slot.turn === 1 && <FontAwesomeIcon icon={faRepeatAlt} className="booking-participant_icon" />}

        {slot.order_financial_status === "paid" && (
          <FontAwesomeIcon icon={faUsdCircle} className="booking-participant_icon" />
        )}

        {slot.no_show_type && slot.no_show_type !== "weather" && (
          <FontAwesomeIcon icon={faBan} className="booking-participant_icon" />
        )}

        {slot.no_show_type === "weather" && (
          <FontAwesomeIcon icon={faThunderstorm} className="booking-participant_icon" />
        )}

        {!mobileSizedDivision && <div className="booking-participant-holes-large">{slot.tee_time_bookings_holes}</div>}
      </>
    );
  };

  const renderBookingCategoryIcons = (teeTimeId: number) => {
    if (!props.teetimeBookingCategories) {
      return;
    }

    const bookingCategories = props.teetimeBookingCategories[teeTimeId];

    if (!bookingCategories) {
      return;
    }

    return (
      <div className="booking-category-icons">
        {bookingCategories?.map((category: ITeeTimeBookingCategory, index: number) => {
          const categoryLabel = category?.title[0]?.toLocaleLowerCase();
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`category-${category.title}`}>{category.title}</Tooltip>}
              key={index}
            >
              <FontAwesomeIcon
                icon={["far", `circle-${categoryLabel}` as IconName]}
                className="booking-category-icon"
              />
            </OverlayTrigger>
          );
        })}
      </div>
    );
  };

  function convertStartTimePeriod(startTime: string) {
    const tempHours = startTime?.split(":");
    const hours = Number(tempHours?.[0]);

    if (hours == null || isNaN(hours)) {
      return "";
    }

    if (hours < 12) {
      return " AM";
    } else {
      return " PM";
    }
  }

  function findMatchingGroupedTeeTime(
    teetime: ITeeTimeTabNew,
    groupedTeeTimes: ITeeTimeDraggable[],
  ): ITeeTimeDraggable {
    for (const moveGroup of props.dragAndDropState.moveGroups) {
      if (moveGroup.sourceTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id) {
        return moveGroup.sourceTeeTime;
      } else if (moveGroup.destTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id) {
        return moveGroup.destTeeTime;
      }
    }

    return groupedTeeTimes?.find(
      groupedTeeTime => groupedTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id,
    );
  }

  async function handlePrintAlphaList(teetime: ITeeTimeTabNew) {
    let tournamentId = 0;
    let leagueId = 0;
    let params;

    if (teetime.slots[0].league_id) {
      leagueId = teetime.slots[0].league_id;
      params = {
        league_id: leagueId,
        tee_sheet_id: teetime.slots[0].tee_sheet_id,
      };
    } else if (teetime.slots[0].tournament_id) {
      tournamentId = teetime.slots[0].tournament_id;
      params = {
        tournament_id: tournamentId,
        tee_sheet_id: teetime.slots[0].tee_sheet_id,
      };
    }

    const alphaListRes = await GetPrintEventAlphaList(params, true);

    if (alphaListRes.status !== StatusCode.OK) {
      dispatch(showError("Error printing event alpha list")); //TODO: Translate
      return;
    }

    window.open().document.write(String(alphaListRes.data));
  }

  async function handlePrintScorecards(teetime: ITeeTimeTabNew) {
    if (facilityStore?.facility?.courses[0]?.divisions?.length > 2) {
      props.handleSelectDivisions(teetime);
      return;
    }

    let tournamentId = 0;
    let leagueId = 0;
    let params;

    if (teetime.slots[0].league_id) {
      leagueId = teetime.slots[0].league_id;
      params = {
        league_id: leagueId,
        tee_sheet_id: teetime?.slots[0]?.tee_sheet_id,
        facility_id: facilityStore?.facility?.id,
        start_time: teetime?.slots[0]?.start_time,
      };
    } else if (teetime.slots[0].tournament_id) {
      tournamentId = teetime.slots[0].tournament_id;
      params = {
        tournament_id: tournamentId,
        tee_sheet_id: teetime.slots[0].tee_sheet_id,
        facility_id: facilityStore?.facility?.id,
        start_time: teetime?.slots[0]?.start_time,
      };
    }

    const eventScorecardsRes = await GetEventScorecards(params, true);

    if (eventScorecardsRes.status !== StatusCode.OK) {
      dispatch(showError("Error printing event scorecard")); //TODO: Translate
      return;
    }

    window.open().document.write(String(eventScorecardsRes.data));
  }

  function navigateToEventAccount(type: "league" | "tournament", eventId: number) {
    const event =
      type === "league"
        ? props.teeSheetLeagues.find(league => league.id === eventId)
        : props.teeSheetTournaments.find(tournament => tournament.id === eventId);

    history.push(`/admin/settings/accounts/overview/${event.account_id}`);
  }

  function tournamentName(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament.name : t("elements.tee_sheet.tee_sheet_tabs.026");
  }

  function leagueName(id: number) {
    const league = props.teeSheetLeagues?.find(league => league.id === id);

    return league !== undefined ? league.name : t("elements.tee_sheet.tee_sheet_tabs.025");
  }

  function tournamentNote(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament?.tee_sheet_note : "";
  }

  function getDivisionCode(teeTimeSlot: ITeeTimeSlotNew) {
    const division = props.allDivisions?.find((division: IDivision) => division.id === teeTimeSlot?.division_id);
    const turnDivision = props?.allDivisions?.find(
      (division: IDivision) => division.id === teeTimeSlot?.turn_division_id,
    );

    if (division) {
      if (facilityStore.teeSheetSettings.display_turn_division_code) {
        return (
          division.code +
          (teeTimeSlot.turn_tee_time_id != null && turnDivision?.code != null ? ` - ${turnDivision.code}` : "")
        );
      } else {
        return division.code;
      }
    } else {
      return "";
    }
  }

  async function printCartSigns(
    date: string,
    shotgun_application_id: number,
    type?: "league" | "tournament",
    eventId?: number,
  ) {
    const cartSignsRes = await GetPrintCartSigns(
      {
        date,
        shotgun_application_id,
        league_id: type === "league" ? eventId : undefined,
        tournament_id: type === "tournament" ? eventId : undefined,
      },
      true,
    );

    if (cartSignsRes.status !== StatusCode.OK) {
      dispatch(showError(t("elements.tee_sheet.tee_sheet_tabs.056")));
      return;
    }

    window.open().document.write(String(cartSignsRes.data));
  }

  async function handleMouseEnter(
    teeTime: ITeeTimeTabNew,
    token?: CancelToken,
  ): Promise<ITeeTimeToolTipPricing | undefined> {
    const pricingRes = await GetTeeTimePricing({ tee_time_id: teeTime.slots[0].tee_time_id }, false, token);

    if ((token && token.reason) || typeof pricingRes.data === "string") {
      return undefined;
    }

    if (pricingRes.status !== Number(StatusCode.OK)) {
      dispatch(showError(pricingRes.message));
      return {
        booking_fee: undefined,
        green_fees: [],
        booking_categories: [],
      };
    }

    return pricingRes.data as ITeeTimeToolTipPricing;
  }

  function findCustomerTypeBackground(slot: ITeeTimeSlotNew) {
    let color = "#FFFFFF";

    if (slot.check_in_status === "checked" && !slot.turn) {
      color = "#82d195";
    } else if (slot.turn) {
      color = "#e7e7e7";
    } else if (slot.no_show_type == "weather") {
      color = "#fcbf49";
    } else if (slot.no_show_type) {
      color = "#d62828";
    } else if (slot.customer_id) {
      color = slot.customer_type_color;
    }

    return color;
  }

  function checkForCheckedInPlayer(slotGroup: ITeeTimeSlotNew[]) {
    return slotGroup?.filter(slot => slot.check_in_status !== "unchecked")?.length > 0;
  }

  async function handleExportShotgunTemplate(teeTime: ITeeTimeTabNew) {
    const params = {
      shotgun_application_id: teeTime.slots[0].shotgun_application_id,
    };

    const exportRes = await ExportShotgunTemplate(params, true);

    if (exportRes.status !== StatusCode.OK) {
      dispatch(showError(t("elements.tee_sheet.tee_sheet_tabs.151")));
      return;
    }

    const templateExport = document.createElement("a");
    templateExport.href = "data:text/csv;charset=utf-8," + encodeURI(String(exportRes.data));
    templateExport.target = "_blank";
    templateExport.download = `${t("elements.tee_sheet.tee_sheet_tabs.152")}_${moment(new Date())
      .format("YYYY-MM-DD")
      .toString()}`
      .replace(/ /g, "_")
      .toLowerCase()
      .concat(".csv");
    templateExport.click();
  }

  const handleNavigateToBookingDetails = (teetimeId: number, slot: ITeeTimeSlotNew) => {
    if (slot.turn === 1) {
      return;
    }

    history.push(`/admin/teesheet/details/${teetimeId}`);
  };

  // Scroll current time into view
  const elementScrollRef = useCallback(element => {
    const tr = timeToNumber();
    const offsetTime = props.sortedTeeTimes
      .filter(teetime => {
        const time = teetime.start_time.replace(":", "");
        if (parseInt(time) <= tr) {
          return true;
        }
        return false;
      })
      .filter((teetime, i, teetimes) => {
        if (i === teetimes.length - 8 /*magic number, 1 hour is approximately 8 indexes*/) {
          return true;
        }
        return false;
      });

    if (formatDate(teeSheetStore.selectedDate as Date) === formatDate(new Date())) {
      if (offsetTime && element?.id === String(offsetTime[0]?.slots?.[0]?.tee_time_id)) {
        element?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    return () => {
      props.updateMainState({
        sortedTeeTimes: null,
        groupedTeeTimes: null,
        selectedTeeTime: null,
        teeSheetLeagues: undefined,
        teeSheetTournaments: undefined,
      });
    };
  }, []);

  async function handleOpenAddPlayer(slot: ITeeTimeSlotNew) {
    const res = await GetTournamentOrganizer({ tournament_id: Number(slot.tournament_id) }, true);

    if (Number(res.status) !== Number(StatusCode.OK)) {
      dispatch(showError("Error getting tournament organizer"));
      return;
    }

    props.updateModalState(
      { isOpen: true, slot: slot, organizer: res.data.length > 0 ? res.data[0].customer : null },
      NewTeeSheetTabsDivisionUpdateModalType.AddTournamentPlayer,
    );
  }

  return (
    <div
      ref={divisionRef}
      className={classNames("tee-sheet-tabs-division", {
        [props.divisionClassName]: !!props.divisionClassName,
      })}
    >
      {props.sortedTeeTimes?.map((teetime, teetimeIndex: number, teetimes) => {
        const prevTeetime = teetimes[teetimeIndex - 1];
        const nextTeetime = teetimes[teetimeIndex + 1];

        const teetimeLoading = loadingTeetimeTabActionsContainsId(
          props.loadingTeetimeTabActions,
          teetime.slots[0].tee_time_id,
        );

        // let turnArrow = false;

        // if (teetime.slots[0].turn_tee_time?.quantity_remaining < teetime.quantity_remaining) {
        //   turnArrow = true;
        // }

        return (
          <Fragment key={teetimeIndex}>
            {/* LEAGUE/TOURNAMENT/SHOTGUN HEADER */}
            {/* LEAGUE HEADER */}
            {teetime.slots[0].league_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].league_id === null ||
              prevTeetime.slots[0].league_id != teetime.slots[0].league_id) ? (
              <div className="background-black text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faUsers} />
                      {props.teeSheetLeagues === undefined ? (
                        <span style={{ display: "inline-flex" }}>
                          <Spin />
                        </span>
                      ) : (
                        leagueName(teetime.slots[0].league_id)
                      )}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("elements.tee_sheet.tee_sheet_tabs.066"),
                              onClick: () =>
                                void printCartSigns(
                                  teetime.slots[0].date,
                                  teetime.slots[0].shotgun_application_id,
                                  "league",
                                  teetime.slots[0].league_id,
                                ),
                            },
                            {
                              icon: "dollar-sign",
                              label: t("elements.tee_sheet.tee_sheet_tabs.067"),
                              onClick: () => void navigateToEventAccount("league", teetime.slots[0].league_id),
                              hidden: !props.teeSheetLeagues?.find(league => league.id === teetime.slots[0].league_id)
                                ?.account_id,
                            },
                            {
                              icon: "trash",
                              label: t("elements.tee_sheet.tee_sheet_tabs.068"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "check",
                              label: t("elements.tee_sheet.tee_sheet_tabs.168"),
                              onClick: () =>
                                props.updateModalState<ICheckInAllLeagueParticipantsModal>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllLeagueParticipants,
                                ),
                            },
                            {
                              icon: "print",
                              label: t("Print Alpha List"), // TODO: Translation
                              onClick: () => void handlePrintAlphaList(teetime),
                            },

                            {
                              icon: "print",
                              label: "Print Scorecards",
                              onClick: () => void handlePrintScorecards(teetime),
                            },

                            // {
                            //   icon: "file-export",
                            //   label: "Export Shotgun Template",
                            //   onClick: () => handleExportShotgunTemplate(teetime),
                            //   hidden: teetime.blocked_type !== "shotgun",
                            // },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TOURNAMENT HEADER */}
            {teetime.slots[0].tournament_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].tournament_id === null ||
              prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id) ? (
              <div className="background-black text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faTrophy} />
                      {props?.teeSheetTournaments === undefined ? (
                        <div style={{ display: "inline-flex" }}>
                          <Spin />
                        </div>
                      ) : (
                        tournamentName(teetime.slots[0].tournament_id)
                      )}
                    </div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        // type=""
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("elements.tee_sheet.tee_sheet_tabs.066"),
                              onClick: () =>
                                void printCartSigns(
                                  teetime.slots[0].date,
                                  teetime.slots[0].shotgun_application_id,
                                  "tournament",
                                  teetime.slots[0].tournament_id,
                                ),
                            },
                            {
                              icon: "dollar-sign",
                              label: t("elements.tee_sheet.tee_sheet_tabs.067"),
                              onClick: () => navigateToEventAccount("tournament", teetime.slots[0].tournament_id),
                              hidden: !props.teeSheetTournaments?.find(
                                tournament => tournament.id === teetime.slots[0].tournament_id,
                              )?.account_id,
                            },
                            {
                              icon: "trash",
                              label: t("elements.tee_sheet.tee_sheet_tabs.068"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              hidden: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "file-export",
                              label: t("elements.tee_sheet.tee_sheet_tabs.156"),
                              onClick: () => void handleExportShotgunTemplate(teetime),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "file-import",
                              label: t("elements.tee_sheet.tee_sheet_tabs.157"),
                              onClick: () =>
                                props.updateModalState<IFileImportModal>(
                                  { isOpen: true, shotgun_application_id: teetime.slots[0].shotgun_application_id },
                                  NewTeeSheetTabsDivisionUpdateModalType.FileImport,
                                ),
                              hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            {
                              icon: "check",
                              label: "Check In Participants",
                              onClick: () =>
                                props.updateModalState<ICheckInAllTournamentParticipantsModal>(
                                  {
                                    isOpen: true,
                                    teetime,
                                  },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllTournamentParticipants,
                                ),
                            },
                            {
                              icon: "print",
                              label: t("Print Alpha List"), // TODO: Translation
                              onClick: () => void handlePrintAlphaList(teetime),
                            },

                            {
                              icon: "print",
                              label: t("Print Scorecards"),
                              onClick: () => void handlePrintScorecards(teetime),
                            },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
                <p>
                  {tournamentNote(teetime.slots[0].tournament_id)
                    ? tournamentNote(teetime.slots[0].tournament_id).toLocaleLowerCase()
                    : ""}
                </p>
              </div>
            ) : null}

            {/* SHOTGUN HEADER */}
            {teetime.slots[0].blocked_type === "shotgun" &&
            teetime.slots[0].tournament_id === null &&
            teetime.slots[0].league_id === null &&
            (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun") ? (
              <div className="background-primary text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>{t("elements.tee_sheet.tee_sheet_tabs.069")}</div>
                    <div className="text-black">
                      <NavigationDropdownNew
                        showPlainTextLabel
                        rightAlign
                        label={<FontAwesomeIcon className="th-ellipsis text-white" icon={faEllipsisV} />}
                        sections={[
                          [
                            {
                              icon: "print",
                              label: t("elements.tee_sheet.tee_sheet_tabs.066"),
                              onClick: () =>
                                void printCartSigns(teetime.slots[0].date, teetime.slots[0].shotgun_application_id),
                            },
                            {
                              icon: "trash",
                              label: t("elements.tee_sheet.tee_sheet_tabs.068"),
                              onClick: () =>
                                props.updateModalState<IRemoveShotgunPopup>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.RemoveShotgun,
                                ),
                              disabled: teetime.slots[0].shotgun_application_id === null,
                            },
                            {
                              icon: "check",
                              label: "Check In Participants",
                              onClick: () =>
                                props.updateModalState<ICheckInAllShotGunParticipantsModal>(
                                  { isOpen: true, teetime },
                                  NewTeeSheetTabsDivisionUpdateModalType.CheckInAllShotgunParticipants,
                                ),
                              // hidden: teetime.slots[0].blocked_type !== "shotgun",
                            },
                            // {
                            //   icon: "print",
                            //   label: "Print Alpha List", // TODO: Translation
                            //   onClick: () => handlePrintAlphaList(teetime),
                            // },
                          ],
                        ]}
                      />
                    </div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TEE TIME CONTAINER */}
            <div
              className={classNames("tee-time-new", {
                "pb-3.5 background-darkgray event-side-border":
                  teetime.slots[0].league_id > 0 || teetime.slots[0].tournament_id > 0,
                "pb-3.5 background-primary-light event-side-border":
                  teetime.slots[0].league_id === null &&
                  teetime.slots[0].tournament_id === null &&
                  teetime.slots[0].blocked_type === "shotgun",
                "pt-3.5":
                  (teetime.slots[0].league_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].league_id === null ||
                      prevTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].tournament_id === null ||
                      prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun")),
                "rounded-bottom event-bottom-border":
                  (teetime.slots[0].league_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].league_id === null ||
                      nextTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].tournament_id === null ||
                      nextTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (nextTeetime === undefined || nextTeetime.slots[0].blocked_type !== "shotgun")),
                "tee-time-new-spaced":
                  teetime.slots[0].league_id === null &&
                  teetime.slots[0].tournament_id === null &&
                  teetime.slots[0].blocked_type !== "shotgun" &&
                  prevTeetime !== undefined,
              })}
              key={teetimeIndex}
              id={String(teetime.slots[0].tee_time_id)}
              ref={elementScrollRef}
            >
              {/* SUNRISE MARKER */}
              {((teetimeIndex === 0 && facilityStore.weather?.sunrise < teetime?.start_time) ||
                (facilityStore.weather?.sunrise >= prevTeetime?.start_time &&
                  facilityStore.weather?.sunrise < teetime?.start_time)) && (
                <div className="flex items-center mb-3.5">
                  <div style={{ marginLeft: "6.4rem" }} className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunrise} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunrise)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}

              {/* HOUR MARKERS */}
              {teetimeIndex === 0 ||
              convertTime(teetime.start_time).split(":")[0] !== convertTime(prevTeetime.start_time).split(":")[0] ? (
                <div className="tee-time hour-block">
                  <p className="tee-time time tee-time hour">
                    {convertTime(teetime.start_time).split(":")[0] +
                      ":00 " +
                      convertTime(teetime.start_time).split(" ")[1]}
                  </p>
                  <div className="tee-time hour-line"></div>
                </div>
              ) : null}

              {/* TEE TIME */}
              <div className="tee-time_container">
                {/* TEE TIME START TIME */}
                <button className="tee-time-time cursor-pointer text-left" onClick={() => {}}>
                  <p
                    className={
                      teetime.slots[0].tournament_id || teetime.slots[0].league_id
                        ? "tee-time-time-text-event"
                        : "tee-time-time-text"
                    }
                  >
                    {teetime.slots[0].blocked_type === "shotgun" ||
                    teetime.slots[0].blocked_type === "shotgun_crossover" ? (
                      <span>{teetime.slots[0].start_hole}</span>
                    ) : (
                      <span>
                        <span>{convertTime(teetime.start_time, true)}</span>
                        {!mobileSizedDivision && <span>{convertStartTimePeriod(teetime.start_time)}</span>}
                      </span>
                    )}
                  </p>
                </button>

                {/* DIVISION CODE */}
                {!mobileSizedDivision && (
                  <p
                    className="tee-time-division-code"
                    style={calculateDivisionColors(
                      props.allDivisions?.find((division: IDivision) => division.id === teetime.slots[0].division_id)
                        ?.color,
                    )}
                  >
                    {getDivisionCode(teetime.slots[0])}
                  </p>
                )}

                {facilityStore.teeSheetSettings?.validate_power_cart_count &&
                  teetime.power_cart_quantity != null &&
                  teetime.carts_available != null && (
                    <OverlayTrigger
                      placement="right"
                      show={teetime.power_cart_numbers?.length > 0 ? undefined : false}
                      overlay={
                        <Tooltip id={`teeTimePowerCartAvailability-${teetimeIndex}-${teetime.slots[0].division_id}`}>
                          {teetime.power_cart_numbers}
                        </Tooltip>
                      }
                    >
                      <div className="tee-time-power-cart-availability">
                        {`${teetime.power_cart_quantity}/${teetime.carts_available}`}
                      </div>
                    </OverlayTrigger>
                  )}

                {/* SLOTS */}
                <div className="tee-time-slots">
                  <Droppable
                    key={teetime.slots[0].tee_time_id.toString()}
                    droppableId={teetime.slots[0].tee_time_id.toString()}
                    type="LIST"
                    direction="horizontal"
                  >
                    {provided => (
                      <span className="row-container" ref={provided.innerRef} {...provided.droppableProps}>
                        {findMatchingGroupedTeeTime(teetime, props.groupedTeeTimes)?.slots?.map(
                          (slotGroup, groupIndex: number, slotGroups) => {
                            const slotId = slotGroup[0]?.tee_time_slot_id.toString();

                            return (
                              <Draggable
                                key={slotId}
                                draggableId={slotId}
                                isDragDisabled={slotGroup.some(
                                  slot =>
                                    slot.tee_time_booking_id == null ||
                                    slot.blocked_type === "crossover" ||
                                    slot.check_in_status === "checked" ||
                                    teetimeLoading,
                                )}
                                index={groupIndex}
                              >
                                {provided => (
                                  <div
                                    className={classNames(
                                      "tee-time-slots_container",
                                      `tee-time-slot_spaced_${slotGroup.length}`,
                                      {
                                        "tee-time-slots_last": teetime.slots.length === groupIndex + 1,
                                      },
                                    )}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    {slotGroup.map(
                                      (slot, slotIndex: number) => {
                                        // BOOKED SLOT
                                        if (slot.customer_id) {
                                          return (
                                            <div
                                              key={slotIndex}
                                              className={classNames("tee-time-slot", {
                                                "tee-time-slot_checked": slot.check_in_status === "checked",
                                                "tee-time-slot_crossover": slot.blocked_type === "crossover",
                                                "tee-time-slot_blocked": slot.blocked_type === "blocked",
                                                "tee-time-slot_no-show": slot.no_show_type !== null,
                                                "tee-time-slot_turn": slot.turn,
                                                "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                                "tee-time-slot_booking_engine":
                                                  slot.tee_time_bookings_source === "booking_engine",
                                                "tee-time-slot_has_notes": slot.has_notes,
                                                "tee-time-slot_customer-type-display":
                                                  facilityStore?.teeSheetSettings?.display_customer_type,
                                                "tee-time-slot_loading": teetimeLoading,
                                              })}
                                              style={{ backgroundColor: findCustomerTypeBackground(slot) }}
                                              onClick={() => {
                                                if (!teetimeLoading) {
                                                  handleNavigateToBookingDetails(slot.tee_time_id, slot);
                                                }
                                              }}
                                            >
                                              <RightClickMenu
                                                disableAllActions={teetimeLoading}
                                                alignment={
                                                  props.teeSheetView !== "side-by-side" ||
                                                  groupIndex < slotGroups.length - 1 ||
                                                  slotGroup.length === 4
                                                    ? "left"
                                                    : "right"
                                                }
                                                informationSection={[
                                                  `${t("elements.tee_sheet.tee_sheet_tabs.070")} ${moment
                                                    .utc(slot.tee_time_bookings_completed_at)
                                                    .local()
                                                    .format("lll")}`,
                                                  ...(slot.no_show_type
                                                    ? [
                                                        <Badge
                                                          key="no_show_badge"
                                                          size="xsmall"
                                                          colour="#FDB022"
                                                          outline
                                                        >
                                                          {slot.no_show_type === "defer"
                                                            ? "Defer Charge"
                                                            : valueToString(slot.no_show_type)}
                                                        </Badge>,
                                                      ]
                                                    : []),
                                                ]}
                                                sections={[
                                                  [
                                                    {
                                                      icon: "pencil",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.071"),
                                                      action: () =>
                                                        void props.handleEditBooking(teetime, slot.tee_time_booking_id),
                                                    },
                                                    {
                                                      icon: "ban",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.072"),
                                                      action: () => {
                                                        const teetimeToCancelDate = moment(slot.date).format(
                                                          "MMMM Do, YYYY",
                                                        );
                                                        const teetimeToCancelTime = convertTime(teetime.start_time);

                                                        props.updateModalState<ICancelBookingPopup>(
                                                          {
                                                            isOpen: true,
                                                            teetimeToCancelDate,
                                                            teetimeToCancelTime,
                                                            teetimeToCancelBookingId: slot.tee_time_booking_id,
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.CancelBooking,
                                                        );
                                                      },
                                                      disabled: checkForCheckedInPlayer(slotGroup),
                                                    },
                                                    {
                                                      icon: "user-slash",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.126"),
                                                      action: () => {
                                                        props.updateModalState<ICancelPlayerPopup>(
                                                          {
                                                            isOpen: true,
                                                            bookingParticipantName: `${slot.customer_first_name} ${slot.customer_last_name}`,
                                                            bookingParticipantId: slot.booking_participant_id,
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.CancelPlayer,
                                                        );
                                                      },
                                                      disabled: slot.check_in_status !== "unchecked",
                                                    },
                                                    {
                                                      icon: "cancel",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.073"),
                                                      action: () => {
                                                        props.updateModalState<INoShowModal>(
                                                          {
                                                            isOpen: true,
                                                            bookingParticipantIds: [slot.booking_participant_id],
                                                            slotGroup: slotGroup,
                                                            bookingId: slot?.tee_time_booking_id,
                                                            teeTimeIndex: teetimeIndex,
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.NoShow,
                                                        );
                                                      },
                                                      disabled: slot.tee_time_booking_participant_status === "no_show",
                                                    },
                                                    {
                                                      icon: "list",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.074"),
                                                      action: () =>
                                                        props.updateModalState<IAuditTrailModal>(
                                                          {
                                                            isOpen: true,
                                                            teetime,
                                                            type: "booking",
                                                            bookingId: slot.tee_time_booking_id,
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                        ),
                                                    },
                                                  ],
                                                  [
                                                    ...(slot.shotgun_application_id
                                                      ? [
                                                          {
                                                            icon: "golf-ball-tee" as IconName,
                                                            title: t("elements.tee_sheet.tee_sheet_tabs.169"),
                                                            action: () =>
                                                              props.updateModalState<IEditStartHoleModal>(
                                                                {
                                                                  isOpen: true,
                                                                  teetime,
                                                                  start_hole: teetime.slots[0].start_hole,
                                                                },
                                                                NewTeeSheetTabsDivisionUpdateModalType.EditStartHole,
                                                              ),
                                                          },
                                                        ]
                                                      : []),
                                                    {
                                                      icon: "circle-info",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.075"),
                                                      action: () =>
                                                        props.updateModalState<ITeeTimeDetailsModal>(
                                                          { isOpen: true, teetime },
                                                          NewTeeSheetTabsDivisionUpdateModalType.TeeTimeDetails,
                                                        ),
                                                    },
                                                    {
                                                      icon: "list",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.076"),
                                                      action: () =>
                                                        props.updateModalState<IAuditTrailModal>(
                                                          {
                                                            isOpen: true,
                                                            teetime,
                                                            type: "teeTime",
                                                          },
                                                          NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                        ),
                                                    },
                                                    {
                                                      icon: "flag",
                                                      title: t("elements.tee_sheet.tee_sheet_tabs.077"),
                                                      action: () =>
                                                        props.updateModalState<ICreateShotgunModal>(
                                                          { isOpen: true, teetime },
                                                          NewTeeSheetTabsDivisionUpdateModalType.CreateShotgun,
                                                        ),
                                                    },
                                                    {
                                                      icon: "distribute-spacing-vertical",
                                                      title: slot.shotgun_application_id
                                                        ? t("elements.tee_sheet.tee_sheet_tabs.158")
                                                        : t("elements.tee_sheet.tee_sheet_tabs.159"),
                                                      action: () =>
                                                        slot.shotgun_application_id
                                                          ? props.updateModalState<IAddTeeTimeModal>(
                                                              { isOpen: true, teetime },
                                                              NewTeeSheetTabsDivisionUpdateModalType.AddTeeTime,
                                                            )
                                                          : props.updateModalState<IAddSqueezeTimeModal>(
                                                              { isOpen: true, teetime },
                                                              NewTeeSheetTabsDivisionUpdateModalType.AddSqueezeTime,
                                                            ),
                                                    },
                                                  ],
                                                ]}
                                              >
                                                <div className="tee-time-slot_content">
                                                  <div className="tee-time-slot-booking-participant">
                                                    <div className="booking-participant_content">
                                                      {!mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                                      <div>
                                                        <div className="booking-participant-name">
                                                          <span>
                                                            {`${slot.customer_first_name} ${slot.customer_last_name}`}
                                                            {slot.guest ? (
                                                              <FontAwesomeIcon
                                                                style={{ marginLeft: "0.5rem" }}
                                                                icon={faCircleG}
                                                                size="1x"
                                                              />
                                                            ) : null}
                                                            {slot.has_high_priority_notes ? (
                                                              <FontAwesomeIcon
                                                                style={{ marginLeft: "0.5rem" }}
                                                                icon={faExclamationCircle}
                                                                size="1x"
                                                                className="text-error"
                                                              />
                                                            ) : null}
                                                          </span>
                                                        </div>

                                                        {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                        !slot.guest ? (
                                                          <div className="booking-participant-customer-type">
                                                            <span>{slot.customer_type_title}</span>
                                                            {slot.customer_type_subtitle ? (
                                                              <span>{` - ${slot.customer_type_subtitle}`}</span>
                                                            ) : null}
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>

                                                    <div className="booking-participant-secondary_content">
                                                      {mobileSizedDivision && (
                                                        <div className="booking-participant-holes-small">
                                                          {slot.tee_time_bookings_holes}
                                                        </div>
                                                      )}
                                                      <div className="booking-participant-secondary_content-icons">
                                                        {mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                                        {slot.tee_time_bookings_source === "booking_engine" && (
                                                          <FontAwesomeIcon
                                                            icon={faEarthAmericas}
                                                            className="booking-participant_icon"
                                                          />
                                                        )}

                                                        {slot.tee_time_bookings_source === "golfnow" && (
                                                          <div className="golfNow-logo">
                                                            <img src="/public/images/gn-logo-small.svg" />
                                                          </div>
                                                        )}

                                                        {slot.has_notes && !slot.guest ? (
                                                          <FontAwesomeIcon
                                                            icon={faStickyNote}
                                                            className="booking-participant_icon"
                                                          />
                                                        ) : null}

                                                        {slot.power_cart_quantity > 0 ? (
                                                          <div className="booking-participant_icon">
                                                            <CustomIcon
                                                              src="../../../public/images/powercart2-01.svg"
                                                              size="small"
                                                            />
                                                          </div>
                                                        ) : (
                                                          <FontAwesomeIcon
                                                            icon={faPersonWalking}
                                                            className="booking-participant_icon"
                                                          />
                                                        )}

                                                        {slot.bag_number !== null && (
                                                          <CustomIcon
                                                            src="../../../public/images/golf-bag.svg"
                                                            size="small"
                                                          />
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </RightClickMenu>
                                            </div>
                                          );
                                        } else {
                                          // UNBOOKED TEE TIME
                                          return (
                                            <div
                                              key={slotIndex}
                                              className={classNames("tee-time-slot", {
                                                "tee-time-slot_crossover":
                                                  slot.blocked_type === "crossover" ||
                                                  slot.blocked_type === "shotgun_crossover",
                                                "tee-time-slot_blocked":
                                                  slot.blocked_type === "blocked" ||
                                                  slot.blocked_type === "shotgun_blocked" ||
                                                  slot.blocked_type === "shotgun_disabled",
                                                "tee-time-slot_no-show":
                                                  slot.no_show_type && slot.no_show_type !== "weather",
                                                "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                                "tee-time-slot_customer-type-display":
                                                  facilityStore?.teeSheetSettings?.display_customer_type,
                                                "tee-time-slot_loading": teetimeLoading,
                                              })}
                                              onClick={() => {
                                                if (!teetimeLoading) {
                                                  if (
                                                    teetime.slots[0].blocked_type === "shotgun_blocked" ||
                                                    teetime.slots[0].blocked_type === "blocked"
                                                  ) {
                                                    props.updateMainState({ selectedTeeTime: teetime });
                                                    props.updateModalState(
                                                      { isOpen: true },
                                                      NewTeeSheetTabsDivisionUpdateModalType.BlockedTeeTime,
                                                    );
                                                  } else {
                                                    void props.handleInitiateBooking(teetime, slot);
                                                  }
                                                }
                                              }}
                                            >
                                              <TeeTimeToolTip
                                                prepaidRequired={false}
                                                cardRequired={false}
                                                parentId={slot.tee_time_slot_id}
                                                onMouseEnter={token => handleMouseEnter(teetime, token)}
                                                disable={props.dragAndDropState.teetimeToolTipDisabled}
                                              >
                                                <RightClickMenu
                                                  disableAllActions={teetimeLoading}
                                                  alignment={
                                                    props.teeSheetView !== "side-by-side" ||
                                                    groupIndex < slotGroups.length - 1
                                                      ? "left"
                                                      : "right"
                                                  }
                                                  sections={[
                                                    //
                                                    //   {
                                                    //     icon: "circle",
                                                    //     title: t("elements.tee_sheet.tee_sheet_tabs.079"),
                                                    //     action: () =>  setBlockedType(teetime, "open"),
                                                    //     disabled: slot.blocked_type === "open",
                                                    //   },
                                                    //   {
                                                    //     icon: "ban",
                                                    //     title: t("elements.tee_sheet.tee_sheet_tabs.080"),
                                                    //     action: () => setBlockedType(teetime, "blocked"),
                                                    //     disabled: slot.blocked_type === "blocked",
                                                    //   },
                                                    //   {
                                                    //     icon: "arrows-repeat",
                                                    //     title: t("elements.tee_sheet.tee_sheet_tabs.081"),
                                                    //     action: () => setBlockedType(teetime, "crossover"),
                                                    //     disabled: slot.blocked_type === "crossover",
                                                    //   },
                                                    // ],
                                                    [
                                                      ...(slot.shotgun_application_id
                                                        ? [
                                                            {
                                                              icon: "golf-ball-tee" as IconName,
                                                              title: t("elements.tee_sheet.tee_sheet_tabs.169"),
                                                              action: () =>
                                                                props.updateModalState<IEditStartHoleModal>(
                                                                  {
                                                                    isOpen: true,
                                                                    teetime,
                                                                    start_hole: teetime.slots[0].start_hole,
                                                                  },
                                                                  NewTeeSheetTabsDivisionUpdateModalType.EditStartHole,
                                                                ),
                                                            },
                                                          ]
                                                        : []),
                                                      {
                                                        icon: "circle-info",
                                                        title: t("elements.tee_sheet.tee_sheet_tabs.082"),
                                                        action: () =>
                                                          props.updateModalState<ITeeTimeDetailsModal>(
                                                            { isOpen: true, teetime },
                                                            NewTeeSheetTabsDivisionUpdateModalType.TeeTimeDetails,
                                                          ),
                                                      },
                                                      {
                                                        icon: "list",
                                                        title: t("elements.tee_sheet.tee_sheet_tabs.083"),
                                                        action: () =>
                                                          props.updateModalState<IAuditTrailModal>(
                                                            {
                                                              isOpen: true,
                                                              teetime,
                                                              type: "teeTime",
                                                            },
                                                            NewTeeSheetTabsDivisionUpdateModalType.AuditTrail,
                                                          ),
                                                      },
                                                      {
                                                        icon: "user",
                                                        title: "Add Player",
                                                        action: () => void handleOpenAddPlayer(slot),
                                                      },
                                                      {
                                                        icon: "flag",
                                                        title: t("elements.tee_sheet.tee_sheet_tabs.084"),
                                                        action: () =>
                                                          props.updateModalState<ICreateShotgunModal>(
                                                            { isOpen: true, teetime },
                                                            NewTeeSheetTabsDivisionUpdateModalType.CreateShotgun,
                                                          ),
                                                      },
                                                      {
                                                        icon: "distribute-spacing-vertical",
                                                        title: slot.shotgun_application_id
                                                          ? t("elements.tee_sheet.tee_sheet_tabs.158")
                                                          : t("elements.tee_sheet.tee_sheet_tabs.159"),
                                                        action: () =>
                                                          slot.shotgun_application_id
                                                            ? props.updateModalState<IAddTeeTimeModal>(
                                                                { isOpen: true, teetime },
                                                                NewTeeSheetTabsDivisionUpdateModalType.AddTeeTime,
                                                              )
                                                            : props.updateModalState<IAddSqueezeTimeModal>(
                                                                { isOpen: true, teetime },
                                                                NewTeeSheetTabsDivisionUpdateModalType.AddSqueezeTime,
                                                              ),
                                                      },
                                                      {
                                                        icon: "ban",
                                                        title: t("elements.tee_sheet.tee_sheet_tabs.160"),
                                                        action: () =>
                                                          props.updateModalState<IRemoveTeeTimePopup>(
                                                            { isOpen: true, teetime },
                                                            NewTeeSheetTabsDivisionUpdateModalType.RemoveTeeTime,
                                                          ),
                                                        disabled: slot.quantity_remaining !== 4,
                                                      },
                                                    ],
                                                  ]}
                                                >
                                                  <div className="tee-time-slot_content">
                                                    {slot.blocked_type !== null && slot.blocked_type !== "open" ? (
                                                      <div className="">
                                                        {slot.blocked_type === "blocked" && (
                                                          <p className="text-center">
                                                            <FontAwesomeIcon
                                                              icon={faBan}
                                                              className="booking-participant_icon"
                                                            />
                                                          </p>
                                                        )}

                                                        {slot.blocked_type === "crossover" && (
                                                          <p className="text-center">
                                                            <FontAwesomeIcon
                                                              icon={faRepeatAlt}
                                                              className="booking-participant_icon"
                                                            />
                                                          </p>
                                                        )}

                                                        {slot.blocked_type === "shotgun" && (
                                                          <p className="text-center">
                                                            <FontAwesomeIcon
                                                              icon={faPlusCircle}
                                                              className="booking-participant_icon"
                                                            />
                                                          </p>
                                                        )}

                                                        {slot.blocked_type === "shotgun_blocked" && (
                                                          <p className="text-center">
                                                            <FontAwesomeIcon
                                                              icon={faBan}
                                                              className="booking-participant_icon"
                                                            />
                                                          </p>
                                                        )}

                                                        {slot.blocked_type === "shotgun_disabled" && (
                                                          <p className="text-center">
                                                            <em>{t("elements.tee_sheet.tee_sheet_tabs.029")}</em>
                                                          </p>
                                                        )}

                                                        {slot.blocked_type === "shotgun_crossover" && (
                                                          <p className="text-center">
                                                            <FontAwesomeIcon
                                                              icon={faRepeatAlt}
                                                              className="booking-participant_icon"
                                                            />
                                                          </p>
                                                        )}
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <p className="text-center">
                                                          <FontAwesomeIcon
                                                            icon={faPlusCircle}
                                                            className="booking-participant_icon"
                                                          />
                                                        </p>
                                                      </div>
                                                    )}
                                                  </div>
                                                </RightClickMenu>
                                              </TeeTimeToolTip>
                                            </div>
                                          );
                                        }
                                      }, // slot group map
                                    )}
                                  </div> // tee-time-slots_container
                                )}
                              </Draggable>
                            );
                          },
                        )}
                        {provided.placeholder}
                      </span>
                    )}
                  </Droppable>
                </div>
                {!mobileSizedDivision && renderBookingCategoryIcons(teetime?.slots?.[0]?.tee_time_id)}
              </div>

              {/* SUNSET MARKER */}
              {((teetimeIndex === teetimes.length - 1 && facilityStore.weather?.sunset > teetime?.start_time) ||
                (facilityStore.weather?.sunset <= nextTeetime?.start_time &&
                  facilityStore.weather?.sunset > teetime?.start_time)) && (
                <div className="flex items-center mb-3.5">
                  <div style={{ marginLeft: "6.4rem" }} className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunset} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunset)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
